import { SELLER } from '../utils/APIUtil';
import AuthService from './auth/AuthService';
import axios from 'axios';

const Auth = new AuthService();
export default class SellerService {
  constructor() {
    this.fetch = this.fetch.bind(this);
  }

  async getSellerList() {
    const res = await this.fetch(SELLER, {
      method: 'GET',
    });
    return Promise.resolve(res);
  }

  async getSellerById(id) {
    const res = await this.fetch(SELLER + '/' + id, {
      method: 'GET',
    });
    return Promise.resolve(res);
  }

  async updateSeller(jsonData, id) {
    const response = await axios.put(SELLER + '/' + id, jsonData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.success) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res.error);
    }
  }

  async makeOfficial(jsonData) {
    const response = await axios.put(SELLER + '/official', jsonData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.result === 'OK') {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res.error);
    }
  }

  async revokeOfficial(jsonData) {
    const response = await axios.put(SELLER + '/official/revoke', jsonData, { headers: { Authorization: 'Bearer ' + Auth.getToken() } });
    const res = response.data;
    if (res.result === 'OK') {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res.error);
    }
  }

  fetch(url, options) {
    // performs api calls sending the required authentication headers
    const headers = {
      'Accept': 'application/json',
    };
    headers['Authorization'] = 'Bearer ' + Auth.getToken();
    return fetch(url, {
      headers,
      ...options,
    })
      .then(this._checkStatus)
      .then(response => response.json());
  }

  _checkStatus(response) {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
  }
}
